import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import NumberFormat from 'react-number-format';
import { Form, Col } from 'react-bootstrap';
import Button from '../../components/Button';
import If from '../../components/If';
import AlertError from '../../components/AlertError';
import AlertSuccess from '../../components/AlertSuccess';
import { STRINGS } from '../../util/strings';
import { ExternalOrgansForm } from '../../models/models';
import './styles.css';

function ExternalOrgans() {
    const history = useHistory();
    const [successfulResponse, setSuccessfulResponse] = useState<boolean>(false);

    const externalOrgansSchema = yup.object().shape({
        name: yup
            .string()
            .required(STRINGS.FORM_FIELD_REQUIRED),
        email: yup
            .string()
            .email(STRINGS.FORM_EMAIL_INVALID),
        address: yup
            .string(),
        phone: yup
            .string()
    })

    const initialValues: ExternalOrgansForm = {
        name: '', email: '', address: '', phone: ''
    }

    const { register, handleSubmit, errors } = useForm({
        defaultValues: initialValues,
        mode: 'onTouched',
        resolver: yupResolver(externalOrgansSchema),
    });

    const onSubmit = (data: any) => {
        // console.log(data);

        setSuccessfulResponse(true);
    };

    const verifyErrorsOnForm = (): boolean => {
        if (errors.name) {
            return true;
        }
        return false;
    }

    return (
        <div className="container container-fluid">
            <If condition={verifyErrorsOnForm()}>
                <AlertError
                    message={STRINGS.ALERT_WARNING_FIELDS}
                />
            </If>
            <If condition={successfulResponse && !verifyErrorsOnForm()}>
                <AlertSuccess
                    message={STRINGS.ALERT_MESSAGE_SUCCESS}
                />
            </If>
            <h3>Cadastro de órgãos externos</h3>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Row className="row-custom">
                    <Form.Group as={Col} controlId="formGridName"
                    >
                        <Form.Label>
                            Nome do órgão externo<em>*</em>
                        </Form.Label>
                        <Form.Control
                            ref={register}
                            type="text"
                            name="name"
                            placeholder="Insira o nome do órgão externo"
                            autoComplete="off"
                            isInvalid={errors.name !== undefined}
                            maxLength={100}
                        />
                        <If condition={errors.name}>
                            <Form.Control.Feedback type="invalid">
                                {errors.name?.message}
                            </Form.Control.Feedback>
                        </If>
                    </Form.Group>
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>
                            E-mail
                        </Form.Label>
                        <Form.Control
                            ref={register}
                            type="email"
                            name="email"
                            isInvalid={errors.email !== undefined}
                            placeholder="Insira o e-mail do órgão externo"
                            autoComplete="off"
                            maxLength={100}
                        />
                        <If condition={errors.email}>
                            <Form.Control.Feedback type="invalid">
                                {errors.email?.message}
                            </Form.Control.Feedback>
                        </If>
                    </Form.Group>
                </Form.Row>
                <Form.Row className="row-custom">
                    <Form.Group as={Col}>
                        <Form.Label>
                            Endereço
                        </Form.Label>
                        <Form.Control
                            ref={register}
                            name="address"
                            type="text"
                            placeholder="Insira o endereço do órgão externo"
                            autoComplete="off"
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label>
                            Telefone
                        </Form.Label>
                        <Form.Control
                            ref={register}
                            as={NumberFormat}
                            getInputRef={register}
                            format="(##) ####-####"
                            name="phone"
                            type="text"
                            placeholder="Insira o telefone do órgão externo"
                            autoComplete="off"
                        />
                    </Form.Group>
                </Form.Row>
                <div className="button-position">
                    <Button
                        title="Cancelar"
                        type="button"
                        contained={false}
                        onClick={() => history.goBack()}
                    />
                    <Button
                        title="Cadastrar"
                        type="submit"
                        contained={true}
                    />
                </div>
            </Form>
        </div>
    );
}

export default ExternalOrgans;